<div class="container">
  <section class="time-sheet-section">
    <app-time-sheet-date-selector
      (weekChange)="onWeekChange($event)"
      [isLoading]="isLoading || isLoadingEntries"
    ></app-time-sheet-date-selector>
    @for (day of weekDays; track day.getTime()) {
    <div>
      <app-time-sheet-day
        [date]="day"
        [projects]="projects()"
        [entries]="filterEntriesByDate(day)"
        [categoryColors]="categoryColors"
        [categories]="getTimeSheetCategories()"
        (onSave)="onTimeSheetEntrySaved($event)"
      ></app-time-sheet-day>
    </div>
    }
  </section>
</div>
